// 模版平台来源
// eslint-disable-next-line import/prefer-default-export
export const TEMPLATE_SOURCE_ENUM = {
    OLD: 1, // 快驴
    NEW: 2, // 小象自建
};
